import React, { Component } from 'react'
import styles from './EightRooms.module.css'
import SongList from './SongList'
import {
  Link,
  DirectLink,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller,
} from 'react-scroll'

const MANIFESTO_HIDDEN_HEIGHT = 300

class EightRooms extends Component {
  handleScrollToManifesto = event => {
    scroller.scrollTo('manifesto', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
    })
  }
  handleScrollToFilms = event => {
    scroller.scrollTo('films', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
    })
  }

  render() {
    const { content } = this.props.pageData

    return (
      <div className={styles.EightRooms}>
        <div className={styles.EightRoomsInner}>
          <div className={styles.intro}>
            <p className={styles.introText}>8 rooms, 8 films, 8 months</p>
            <span
              onClick={this.handleScrollToFilms}
              className={styles.readMore}
            >
              Watch Films
            </span>
            <span
              onClick={this.handleScrollToManifesto}
              className={styles.readMore}
            >
              Read Full Manifesto
            </span>
          </div>
          <Element name="films">
            <SongList {...this.props} />
          </Element>
          <Element
            name="manifesto"
            className={styles.content}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
    )
  }
}

export default EightRooms



// WEBPACK FOOTER //
// ./src/components/EightRooms/EightRooms.js